// eslint-disable-next-line import/no-extraneous-dependencies
import jsCookie from 'js-cookie';
// eslint-disable-next-line import/no-cycle
import Baseunified from './micro/baseunified';

const base = new Baseunified();
const dslModel = base.getDslModel();
const canOperate = (codes, type) => {
  let extend;
  // type===1 是后端按钮权限
  if (type === '1') {
    const eleString = localStorage.getItem('elements');
    if (!eleString) {
      return false;
    }
    extend = JSON.parse(eleString);
  } else {
    extend = dslModel.elements;
  }
  // eslint-disable-next-line prefer-const
  if (!extend) {
    return false;
  }
  let index = 0;
  // eslint-disable-next-line vars-on-top, no-plusplus, no-var
  for (let i = 0; i < codes.length; i++) {
    const code = codes[i];
    if (type === '1') {
      index = extend.findIndex((item) => item.resourceCode === code);
    } else {
      index = extend.findIndex((item) => item === code);
    }
    if (index > 0) {
      // eslint-disable-next-line no-param-reassign
      break;
    }
  }

  return !(index < 0);
};
const Cookies = jsCookie;
const clearBrowserCache = () => {
  // 清除Cookies
  try {
      document.cookie.split(";").forEach((c) => {
          document.cookie = c.trim().split("=")[0] + '=;expires=' + new Date(0).toUTCString() + ';path=/';
      });
      console.log("Cookies清理成功");
  } catch (error) {
      console.error("Cookies清理失败:", error);
  }

  // 清除Session Storage
  try {
      sessionStorage.clear();
      console.log("Session Storage清理成功");
  } catch (error) {
      console.error("Session Storage清理失败:", error);
  }

  // 清除Local Storage中特定的键columns
  const keysToRemove = ['Renewal', 'workflow_add', 'workflow_edit'];
  try {
      keysToRemove.forEach(key => localStorage.removeItem(key));
      console.log("Local Storage中特定键清理成功");
  } catch (error) {
      console.error("Local Storage中特定键清理失败:", error);
  }

  // 清除Local Storage中的其他键
  // try {
  //     for (const key in localStorage) {
  //         if (!keysToRemove.includes(key)) {
  //             localStorage.removeItem(key);
  //         }
  //     }
  //     console.log("Local Storage中的其他键清理成功");
  // } catch (error) {
  //     console.error("Local Storage中的其他键清理失败:", error);
  // }

  // 清除Service Workers缓存
  if ('caches' in window) {
      caches.keys().then((names) => {
          Promise.all(names.map(name => caches.delete(name)))
              .then(() => {
                  console.log("Service Workers缓存清理成功");
              })
              .catch((error) => {
                  console.error("Service Workers缓存清理失败:", error);
              });
      }).catch((error) => {
          console.error("获取Service Workers缓存键失败:", error);
      });
  }

  // 清除IndexedDB
  if ('indexedDB' in window) {
      indexedDB.databases().then((databases) => {
          Promise.all(databases.map(db => indexedDB.deleteDatabase(db.name)))
              .then(() => {
                  console.log("IndexedDB清理成功");
              })
              .catch((error) => {
                  console.error("IndexedDB清理失败:", error);
              });
      }).catch((error) => {
          console.error("获取IndexedDB数据库失败:", error);
      });
  }

  console.log("浏览器缓存清理操作完成");
}


const toClearCache = () => {
  clearBrowserCache()
  window.location.reload(true);
};
// 判断uiInfo是否存在
const isJSONString = (key) => {
  const value = localStorage.getItem(key);

  try {
    const parsedValue = JSON.parse(value);
    return typeof parsedValue === 'object' && parsedValue !== null;
  } catch (error) {
    return false;
  }
};
// 判断json字符串是不是数组 是的话返回 不是返回空数组
const parseJSONIfArray = (jsonString) => {
  try {
    const parsedData = JSON.parse(jsonString);
    return Array.isArray(parsedData) ? parsedData : [];
  } catch (error) {
    return [];
  }
};
const setFavicon = (url) => {
  // 创建一个新的<link>元素
  const favicon = document.createElement('link');
  favicon.rel = 'icon';
  favicon.type = 'image/x-icon';
  favicon.href = url;

  // 获取文档头部并移除旧的<link>元素
  const { head } = document;
  const existingFavicon = head.querySelector('link[rel="icon"]');
  if (existingFavicon) {
    head.removeChild(existingFavicon);
  }

  // 将新的<link>元素添加到文档头部
  head.appendChild(favicon);
};
const getMenuName = () =>{
  // Assume menuList is an array stored in localStorage as a string.
  // Ensure to use try-catch to handle any unexpected errors
  // and prevent them from affecting the rest of the process.

  try {
    // 获取当前页面的路径。
    let urlPath = '';
    if(window.location.search.includes('objectId')) {
      urlPath = `${window.location.pathname}${window.location.search}`;
    }else {
      urlPath = window.location.pathname;
    }
    // 尝试从localStorage中获取menuList，如果获取失败则设为空数组。
    let menuList = [];
    const storedMenuList = localStorage.getItem('menuList');
    if (storedMenuList) {
      menuList = JSON.parse(storedMenuList);
    }

    // 仅当menuList为非空数组时才继续处理。
    if (Array.isArray(menuList) && menuList.length > 0) {
      // 变量来存储找到的menuCode，初始化为空字符串。
      let foundMenuCode = '';

      // 遍历menuList中的每个元素。
      menuList.forEach(menu => {
        if (Array.isArray(menu.children)) {
          // 遍历children数组。
          menu.children.forEach(child => {
            if (child.menuUrl === urlPath) {
              // 当menuUrl与当前页面路径匹配时，更新foundMenuCode。
              foundMenuCode = child.menuName;
            }
          });
        }
      });

      // 返回最后一个匹配项的menuCode，如果无匹配项则返回空字符串。
      return foundMenuCode;
    }
  } catch (e) {
    // 在控制台打印错误信息，实际应用中可能需要更复杂的错误处理策略。
    console.error('Failed to get menu code:', e);
  }

  // 如果try块中的代码因为任何原因失败，函数将返回空字符串。
  return '';
}


const getObjectIdFromUrl = () => {
  try {
    // 获取当前页面的 URL
    const urlString = window.location.href;
    // 解析 URL 中的参数部分
    const url = new URL(urlString);
    // 获取参数对象
    const params = new URLSearchParams(url.search);
    // 获取参数名为 "objectId" 的值
    const objectId = params.get("objectId");
    // 返回 objectId 的值，如果不存在则返回默认值 "99999"
    return objectId || "99999";
  } catch (error) {
    // 如果发生错误，返回默认值 "99999" 并记录错误信息到控制台
    console.error("Error while parsing objectId from URL:", error);
    return "99999";
  }
}

const getMenuUrl = () => {
  try {
    // 获取当前页面的路径。
    let urlPath = '';
    if(window.location.search.includes('objectId')) {
      urlPath = `${window.location.pathname}${window.location.search}`;
    }else {
      urlPath = window.location.pathname;
    }
    return urlPath;
  } catch (e) {
    // 在控制台打印错误信息，实际应用中可能需要更复杂的错误处理策略。
    console.error('Failed to get menu code:', e);
  }

  // 如果try块中的代码因为任何原因失败，函数将返回空字符串。
  return '';
}

const getApiKeyFromURL = () => {
  // 获取当前浏览器URL
  var url = window.location.href;

  // 使用URLSearchParams对象解析URL
  var params = new URLSearchParams(url);

  // 检查是否存在apiKey参数
  if (params.has('layoutApiKey')) {
      // 返回apiKey的值
      return params.get('layoutApiKey');
  } else {
      // 没有apiKey参数，返回空字符串
      return '';
  }
}


const uuid4 = () => {
  const crypto = window.crypto;

  if (crypto && crypto.randomUUID) {
    return crypto.randomUUID().replace(/-/g, '');
  }

  const getRandomByte =
    crypto && crypto.getRandomValues ? () => crypto.getRandomValues(new Uint8Array(1))[0] : () => Math.random() * 16;

  // http://stackoverflow.com/questions/105034/how-to-create-a-guid-uuid-in-javascript/2117523#2117523
  // Concatenating the following numbers as strings results in '10000000100040008000100000000000'
  return (([1e7]) + 1e3 + 4e3 + 8e3 + 1e11).replace(/[018]/g, c =>
    // eslint-disable-next-line no-bitwise
    ((c) ^ ((getRandomByte() & 15) >> ((c) / 4))).toString(16),
  );
}

const getMenuCode = () =>{
  // Assume menuList is an array stored in localStorage as a string.
  // Ensure to use try-catch to handle any unexpected errors
  // and prevent them from affecting the rest of the process.

  try {
    // 获取当前页面的路径。
    let urlPath = '';
    if(window.location.search.includes('objectId')) {
      urlPath = `${window.location.pathname}${window.location.search}`;
    }else {
      urlPath = window.location.pathname;
    }
    // 尝试从localStorage中获取menuList，如果获取失败则设为空数组。
    let menuList = [];
    const storedMenuList = localStorage.getItem('menuList');
    if (storedMenuList) {
      menuList = JSON.parse(storedMenuList);
    }

    // 仅当menuList为非空数组时才继续处理。
    if (Array.isArray(menuList) && menuList.length > 0) {
      // 变量来存储找到的menuCode，初始化为空字符串。
      let foundMenuCode = '';

      // 遍历menuList中的每个元素。
      menuList.forEach(menu => {
        if (Array.isArray(menu.children)) {
          // 遍历children数组。
          menu.children.forEach(child => {
            if (child.menuUrl === urlPath) {
              // 当menuUrl与当前页面路径匹配时，更新foundMenuCode。
              foundMenuCode = child.menuCode;
            }
          });
        }
      });

      // 返回最后一个匹配项的menuCode，如果无匹配项则返回空字符串。
      return foundMenuCode;
    }
  } catch (e) {
    // 在控制台打印错误信息，实际应用中可能需要更复杂的错误处理策略。
    console.error('Failed to get menu code:', e);
  }

  // 如果try块中的代码因为任何原因失败，函数将返回空字符串。
  return '';
}

const getPathFromRouteCache = () => {
  // 检查localStorage中是否存在routeCache
  if (!localStorage.getItem('routeCache')) {
      console.error("localStorage中不存在routeCache");
      return '';
  }

  // 从localStorage中获取routeCache
  var routeCache = localStorage.getItem('routeCache');

  // 尝试解析routeCache为JSON格式
  try {
      routeCache = JSON.parse(routeCache);
  } catch (error) {
      console.error("解析routeCache时出错:", error);
      return '';
  }

  // 检查routeCache是否为数组
  if (!Array.isArray(routeCache)) {
      console.error("routeCache不是一个数组");
      return '';
  }

  // 检查routeCache的长度是否大于等于2
  if (routeCache.length < 2) {
      console.error("routeCache数组长度小于2");
      return '';
  }

  // 获取数组的倒数第二项
  var item = routeCache[routeCache.length - 2];

  // 检查倒数第二项的query是否存在layoutApiKey和objectId参数
  if (item.query && item.query.layoutApiKey && item.query.objectId) {
      // 构建path
      var path = item.path + '?objectId=' + item.query.objectId + '&layoutApiKey=' + item.query.layoutApiKey;
      return path;
  } else {
      // 如果不存在layoutApiKey和objectId参数，只返回path
      return item.path || '';
  }
}

/**
 * 检查用户是否有权限访问指定路由
 * @param {string} routePath - 路由路径
 * @returns {boolean} - 是否有权限
 */
const hasRoutePermission = (routePath) => {
  try {
    // 如果路径是基座路由，直接允许访问
    const baseRoutes = ['/', '/login', '/recommend', '/IndividualCenter', '/flyingBook', '/openAgain', '/middle', '/saasLogin', '/optimizeIndex', '/push', '/singleSignOn', '/tps'];
    if (baseRoutes.includes(routePath)) {
      return true;
    }

    // 从localStorage获取菜单列表
    const storedMenuList = localStorage.getItem('menuList');
    if (!storedMenuList) {
      // 如果没有菜单列表，可能是未登录或权限未加载，默认不允许访问业务路由
      return false;
    }

    const menuList = JSON.parse(storedMenuList);
    if (!Array.isArray(menuList) || menuList.length === 0) {
      return false;
    }

    // 处理带查询参数的路由路径
    let urlPath = routePath;
    if (routePath.includes('?')) {
      urlPath = routePath.split('?')[0];
    }

    // 遍历菜单列表，检查是否有匹配的路由
    for (const menu of menuList) {
      // 检查一级菜单
      const menuUrl = menu.menuUrl || menu.menuPath || '';
      if (menuUrl && menuUrl !== '-1') {
        // 精确匹配
        if (menuUrl === routePath || menuUrl === urlPath) {
          return true;
        }
        // 对于微前端路由，检查路径是否以菜单路径开头
        if (routePath.startsWith(menuUrl) || urlPath.startsWith(menuUrl)) {
          return true;
        }
      }

      // 检查子菜单
      if (Array.isArray(menu.children)) {
        for (const child of menu.children) {
          const childMenuUrl = child.menuUrl || child.menuPath || '';
          if (childMenuUrl && childMenuUrl !== '-1') {
            // 精确匹配
            if (childMenuUrl === routePath || childMenuUrl === urlPath) {
              return true;
            }
            // 对于微前端路由，检查路径是否以菜单路径开头
            if (routePath.startsWith(childMenuUrl) || urlPath.startsWith(childMenuUrl)) {
              return true;
            }
          }
        }
      }
    }

    return false;
  } catch (error) {
    console.error('权限检查失败:', error);
    // 出错时默认不允许访问，保证安全性
    return false;
  }
}

const downloadFromUrlString = (urlString) => {
  try {
      // 检查是否包含 'URL='
      const urlIndex = urlString.indexOf('URL=');
      if (urlIndex === -1) throw new Error('URL= not found in the input string');

      // 提取 URL 部分
      const urls = urlString.substring(urlIndex + 4);
      const url = new URL(urls);
      const params = new URLSearchParams(url.search);

      // 检查是否有 fileName 字段
      if (params.has('fileName')) {
          const fileName = params.get('fileName');

          // 使用 fetch 获取文件流并下载
          fetch(urls)
              .then(response => response.blob())
              .then(blob => {
                  const a = document.createElement('a');
                  const objectUrl = window.URL.createObjectURL(blob);
                  a.href = objectUrl;
                  a.download = fileName;
                  document.body.appendChild(a);
                  a.click();
                  window.URL.revokeObjectURL(objectUrl);
                  document.body.removeChild(a);
              })
              .catch(error => console.error('Download failed:', error));
      } else {
          // 如果不存在 fileName 字段，直接打开 URL
          window.open(urls);
      }
  } catch (error) {
      console.error('An error occurred:', error.message);
  }
}
export {
  // eslint-disable-next-line import/prefer-default-export
  canOperate,
  Cookies,
  toClearCache,
  isJSONString,
  parseJSONIfArray,
  setFavicon,
  uuid4,
  getObjectIdFromUrl,
  getApiKeyFromURL,
  getPathFromRouteCache,
  getMenuCode,
  downloadFromUrlString,
  hasRoutePermission
};
